/**
 * ThemeOverride constants and CSS variable mapping tables.
 *
 * Centralises the mapping from ThemeOverrideConfig property paths
 * to CSS custom property names set on the scoped wrapper element.
 */

// ---------------------------------------------------------------------------
// Color Palette / Shade Lists
// ---------------------------------------------------------------------------

/** All color palette names supported by ThemeColorOverrides. */
export const COLOR_PALETTES = [
  'primary',
  'secondary',
  'accent',
  'success',
  'warning',
  'error',
  'info',
] as const;

/** All shade values for a full ColorScale (50-950). */
export const COLOR_SHADES = [
  '50', '100', '200', '300', '400', '500',
  '600', '700', '800', '900', '950',
] as const;

// ---------------------------------------------------------------------------
// Typography Key Map
// ---------------------------------------------------------------------------

/** Maps ThemeTypographyOverrides keys to CSS custom property names. */
export const TYPOGRAPHY_KEY_MAP: Record<string, string> = {
  fontSans: '--font-sans',
  fontMono: '--font-mono',
} as const;

// ---------------------------------------------------------------------------
// Border Radius Key Map
// ---------------------------------------------------------------------------

/** Maps ThemeBorderRadiusOverrides keys to CSS custom property names. */
export const RADIUS_KEY_MAP: Record<string, string> = {
  sm: '--radius-sm',
  DEFAULT: '--radius',
  md: '--radius-md',
  lg: '--radius-lg',
  xl: '--radius-xl',
  '2xl': '--radius-2xl',
} as const;

// ---------------------------------------------------------------------------
// Shadow Key Map
// ---------------------------------------------------------------------------

/** Maps ThemeShadowOverrides keys to CSS custom property names. */
export const SHADOW_KEY_MAP: Record<string, string> = {
  sm: '--shadow-sm',
  DEFAULT: '--shadow',
  md: '--shadow-md',
  lg: '--shadow-lg',
  xl: '--shadow-xl',
} as const;
